import { Platform, StyleSheet } from 'react-native';
import { isWeb } from './utils/Helper';




export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'Marcellus-Regular',
    fontWeight: 300,
  },
  SECONDARY_FONT: {
    fontFamily: 'Lato-Regular',
    fontWeight: 300,
  },

  FONT_XSMALL: {
    fontSize: 8,
    lineHeight: 14,
    fontWeight: 500
  },
  FONT_SMALL: {
    fontSize: 12,
    lineHeight: 16,
  },
  FONT_MEDIUM: {
    fontSize: 16,
    lineHeight: 20,
  },
  FONT_LARGE: {
    fontSize: 23,
    lineHeight: 26,
    fontWeight: 300,
  },
  FONT_XLARGE: {
    fontSize: 32,
    lineHeight: 36,
    fontWeight: 400,
  },
  FONT_XXLARGE: {
    fontSize: 30,
    lineHeight: 36,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFFFF', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#000000',

    BACKGROUND_COLOR_SECONDARY: "#014F70", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

    PRIMARY_COLOR: "#FFFFFF", // primary color
    PRIMARY_TEXT_COLOR: "#000000", // primary text color

    SECONDARY_COLOR: "#937033", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#937033",
    ACCENT_Text_COLOR: "#D9D9D9",

    TERTIARY_TEXT_COLOR: "#858585",
  },
};


export default StyleSheet.create({
  mainContainerHeaderContainer: {
    display: "none",
  },
  headerContainer: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY
  },
  widgetmainContainerHeaderTitleContainer: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    marginTop: -20,
    paddingTop: 34,
    backgroundColor: theme.COLORS.WHITE,
  },
  widgetmainContainerHeaderTitle: {
    color: theme.COLORS.BACKGROUND_COLOR_CONTRAST
  },

  backIcon: {
    tintColor: theme.COLORS.WHITE,
    filter: "invert(1)",
  },
  backText: {
    color: theme.COLORS.WHITE,
  },
  notificationIcon: {
    tintColor: theme.COLORS.WHITE,
    filter: "invert(1)",
  },
  headerContainerLogo: {
    width: 140,
    height: 24
  },
  tabBarStyle: {
    display: "none"
  },
  primaryBtn: {
    borderRadius: 0
  },
  secondaryBtn: {
    borderRadius: 0
  },
  tertiaryBtn: {
    borderRadius: 0
  },

  multipleLargeWidgetContainer: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    marginTop: -20,
    paddingTop: 34,
  },
  multipleLargeWidget_WidgetsTitleText: {
    ...theme.FONT_LARGE,
  },
  "multipleLargeWidgetTitleContainer_dining-top-widget": {
    display: "none"
  },
  multipleLargeWidgetViewAll: {
    display: "none"
  },
  multipleLargeWidgetTextContainer: {
    width: "100%",
    maxWidth: "100%",
  },
  multipleLargeWidgetTitleText: {
    ...theme.FONT_XLARGE,
    textAlign: "center",
  },
  multipleLargeWidget_WidgetsImg: {
    borderRadius: 5,
    height: 244,
  },
  multipleLargeWidget_WidgetsContainer: {
    height: 244,
    width: 163,
  },
  "multipleLargeWidget_WidgetsContainer_dining-long-widget": {
    width: 261,
    height: 182
  },
  "multipleLargeWidget_WidgetsImg_dining-long-widget": {
    height: 182
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    gap: 6
  },
  multipleLargeWidget_MainWidgetsContainer: {
    marginTop: 20
  },


  hcommerce_storelevel1_HeaderContainer: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    marginTop: -20,
    backgroundColor: theme.COLORS.WHITE,
  },
  hcommerce_storelevel1_Pill: {
    padding: 14,
    borderWidth: 1,
    borderBottomWidth: 1,
    borderRadius: 5,
    borderColor: "#555759"
  },
  hcommerce_storelevel1_SelectedPill: {
    backgroundColor: theme.COLORS.SECONDARY_COLOR,
    borderColor: theme.COLORS.SECONDARY_COLOR,
  },
  hcommerce_storelevel1_SelectedPill_Text: {
    color: theme.COLORS.SECONDARY_TEXT_COLOR,
  },
  hcommerce_storelevel1_PillContainer: {
    paddingHorizontal: 17,
    gap: 10,
  },
  hcommerce_storelevel1_ChildContainer_Title: {
    textAlign: "center",
  },
  hcommerce_storelevel1_HeaderImg: {
    display: "flex",
  },
  hcommerce_storelevel1_HeaderTitleContainer: {
    display: "none",
  },
  hcommerce_storelevel1_HeaderTitle: {
    color: theme.COLORS.SECONDARY_TEXT_COLOR
  },
  hcommerce_storelevel1_MainContainerChildContainerPillContainer: {
    marginTop: 30,
    marginBottom: 34
  },
  hcommerce_storelevel1_ChildContainer: {
    paddingTop: 0,
    gap: 6,
  },
  hcommerce_orderdetails_MainContainerChildContainer_titlecontainer: {
    paddingTop: 34
  },
  hcommerce_storelevel1_Pill_Text: {
    textTransform: "uppercase",
    color: "#555759"
  },
  list_itemContainer_image: {
    display: "none",
  }

  
});
